<template>
  <!--begin::Basic info-->
  <div class="card mb-5 mb-xl-10">
    <!--begin::Content-->
    <TambahFitur></TambahFitur>
    <!--end::Content-->
  </div>
</template>
<script>
import TambahFitur from "@/components/1crm/fitur/master-fitur/add.vue";
import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "add-master-fitur",
  components: {
    TambahFitur,
  },
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_SEKOLAH);
      setCurrentPageBreadcrumbs("Tambah Master Fitur", ["Management Fitur", "Master Fitur"]);
    });
  },
});
</script>
